import { blue, deepPurple, green, lime, orange, red, yellow } from '@material-ui/core/colors';

export const ASYNC_SALE_EXP_START_COLOR = green[500];
export const ASYNC_SALE_EXP_END_COLOR = red[700];
export const SYNC_SALE_EXP_COLOR = orange[500];
export const EXP_OF_INT_SALE_EXP_START_COLOR = blue[500];
export const EXP_OF_INT_SALE_EXP_END_COLOR = deepPurple[500];
export const OFF_COLL_SALE_EXP_START_COLOR = yellow[600];
export const OFF_COLL_SALE_EXP_END_COLOR = lime[500];
